import {
  GET_BATCH_FILES_REQUEST,
  GET_BATCH_FILES_SUCCESS,
  GET_BATCH_FILES_FAILURE,
  SEARCH_BATCH_FILES_REQUEST,
  SEARCH_BATCH_FILES_SUCCESS,
  SEARCH_BATCH_FILES_FAILURE,
  GET_BATCH_FILE_PDF_REQUEST,
  GET_BATCH_FILE_PDF_SUCCESS,
  GET_BATCH_FILE_PDF_FAILURE,
  OPEN_DELETE_FILE_MODAL,
  CLOSE_DELETE_FILE_MODAL,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function batchFiles(state = {
  isGettingBatchFiles: false,
  isFetchingBatchFilePdf: false,
  batchFiles: [],
  batchFilesCount: 0,
  filteredValues: [],
  batchFilePdfData: null,
  batchFilePdfError: null
}, action) {
  switch (action.type) {
    case DELETE_FILE_REQUEST:
      return {
        ...state,
        isDeletingFile: action.isDeletingFile
      };
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        isDeletingFile: action.isDeletingFile,
        deleteFileResponse: action.deleteFileResponse,
        deleteFileError: action.deleteFileError
      };
    case DELETE_FILE_FAILURE:
      return {
        ...state,
        isDeletingFile: action.isDeletingFile,
        deleteFileError: action.deleteFileError
      };
    case CLOSE_DELETE_FILE_MODAL:
      return {
        ...state,
        isDeleteFileModalShown: action.isDeleteFileModalShown,
        deleteFileResponse: action.deleteFileResponse,
        deleteFileError: action.deleteFileError
      };
    case OPEN_DELETE_FILE_MODAL:
      return {
        ...state,
        isDeleteFileModalShown: action.isDeleteFileModalShown,
        fileId: action.fileId
      };
    case GET_BATCH_FILES_REQUEST:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles
      };
    case GET_BATCH_FILES_SUCCESS:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles,
        batchFiles: action.batchFiles,
        batchFilesCount: action.batchFilesCount
      };
    case GET_BATCH_FILES_FAILURE:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles,
        getBatchFilesError: action.getBatchFilesError
      };
    case SEARCH_BATCH_FILES_REQUEST:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles
      };
    case SEARCH_BATCH_FILES_SUCCESS:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles,
        batchFiles: action.batchFiles,
        batchFilesCount: action.batchFilesCount
      };
    case SEARCH_BATCH_FILES_FAILURE:
      return {
        ...state,
        isGettingBatchFiles: action.isGettingBatchFiles,
        getBatchFilesError: action.getBatchFilesError
      };
    case GET_BATCH_FILE_PDF_REQUEST:
      return {
        ...state,
        isFetchingBatchFilePdf: action.isFetchingBatchFilePdf,
        batchFileOriginalFileName: null,
        batchFilePdfData: null,
        batchFilePdfError: null
      };
    case GET_BATCH_FILE_PDF_SUCCESS:
      return {
        ...state,
        isFetchingBatchFilePdf: action.isFetchingBatchFilePdf,
        batchFilePdfData: action.batchFilePdfData,
        batchFileOriginalFileName: action.batchFileOriginalFileName,
        batchFilePdfError: null
      };
    case GET_BATCH_FILE_PDF_FAILURE:
      return {
        ...state,
        isFetchingBatchFilePdf: action.isFetchingBatchFilePdf,
        batchFileOriginalFileName: null,
        batchFilePdfData: null,
        batchFilePdfError: action.batchFilePdfError
      };
    default:
      return state;
  }
}

export default batchFiles;
